
















































import { relationshipColors } from '@/constants';
import Card from '@/components/Card.vue';
import D3 from '@/components/D3.vue';
import Relationship from '@/components/Relationship.vue';
import Node from '@/components/Node.vue';
import { computed, createComponent } from '@vue/composition-api';

export default createComponent({
  name: 'ProvLegendCard',
  components: { Node, Card, Relationship, D3 },
  props: {
    nodeRadius: { type: Number, required: true },
    nodeOutline: { type: String, required: true },
    studyOutline: { type: String, required: true },
  },
  setup(props) {
    return {
      relationshipLegend: computed(() => {
        return Object.entries(relationshipColors).map(([relationship, info]) => {
          return {
            ...info,
            sourceRadius: info.source === 'entity' ? props.nodeRadius : 0,
            targetRadius: info.target === 'entity' ? props.nodeRadius : 0,
            relationship,
          };
        });
      }),
      nodes: [
        {
          type: 'Entity',
          color: props.nodeOutline,
          rx: props.nodeRadius,
        },
        {
          type: 'Activity',
          color: props.nodeOutline,
        },
        {
          type: 'Study',
          color: props.studyOutline,
        },
      ],
    };
  },
});
